import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChildCategoryFormLayer from "../components/ChildCategoryFormLayer";

const ChildCategoryFormPage = () => {
    return (
        <MasterLayout>
            <ChildCategoryFormLayer />
        </MasterLayout>
    );
};

export default ChildCategoryFormPage;
